import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import './index.css'
import CircularButtonGroup from '../../../../../_components/common/CircularButtonGroup';
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';

import AchievementLogo from '../../../../../images/AOlogo.png';
import RelationshipLogo from '../../../../../images/ROlogo.png';
import LeadershipLogo from '../../../../../images/LEOlogo.png';
import LearningLogo from '../../../../../images/LOlogo.png';
import NurturingLogo from '../../../../../images/NOlogo.png';
import SwotIcon from '../../../../../images/swotIcon.png';

class Comparison extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			teamName: '',
			teamId: '',
			getPaUserPermissionListResponse: '',
			id: null,
			modal: false,
			modalContent: null,
			view_detailed_comparison: null,
			navData: [{
				navName: "Analyze",
				link: `/organisation/${props.match.params.id}/user`
			},
			{
				navName: "Org Admin Area",
				link: `/organisation/${props.match.params.id}/org-admin`
			},
			{
				navName: "Super Admin Area",
				link: `/organisation/${props.match.params.id}/super-admin`
			}],
			button_data: [
				{
					img: SwotIcon,
					link: '/organisation/1/user/swot/0',
					name: "Collaboration",
					id: null,
					tooltip_id: 0
				},
				{
					img: AchievementLogo,
					link: '/organisation/1/user/swot/1',
					id: "ACHIEVEMENT",
					name: "Achievement Orientation",
					tooltip_id: 1
				},
				{
					img: RelationshipLogo,
					link: '/organisation/1/user/swot/2',
					id: "RELATIONSHIP",
					name: "Relationship Orientation",
					tooltip_id: 2
				},
				{
					img: LeadershipLogo,
					link: '/organisation/1/user/swot/3',
					id: "LEADERSHIP",
					name: "Leadership Orientation",
					tooltip_id: 3
				},
				{
					img: LearningLogo,
					link: '/organisation/1/user/swot/4',
					id: "LEARNING",
					name: "Learning Orientation",
					tooltip_id: 4
				},
				{
					img: NurturingLogo,
					link: '/organisation/1/user/swot/5',
					id: "NURTURING",
					name: "Nurturing Orientation",
					tooltip_id: 5
				},
			],
		}
	}

	componentDidMount() {
		this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
		if (this.props.saveModulePermissionsResponse === '' || (+this.props.saveTeamDetailsResponse.orgId !== +this.props.match.params.id)) {
			const fd = {
				"pa_user_email": localStorage.getItem('user_email'),
				"organisation_id": +this.props.match.params.id
			}
			this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => {
				this.props.dispatch(saveModulePermissionsAction.saveModulePermissionsHandler(this.props.getModulePermissionsListResponse))
				this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())

			}))
		}
		else {
			this.props.saveModulePermissionsResponse.filter(
				(data, i) => {
					if (data.module_list__module_name === 'Comparison') {
						return data
					}
				}
			).length === 0 &&
				this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
		}
		this.props.dispatch(saveTeamDetailsAction.requestSaveTeamDetailHandler())
		if (this.props.saveTeamDetailsResponse === '') {
			const fd1 = {
				"pa_user_email": localStorage.getItem('user_email'),
				"analytic_organisation_id": +this.props.match.params.id,
			}
			this.props.dispatch(orgAdminAction.getPaUserPermissionListHandler(fd1, () => {
				const reformatdata1 = this.props.getPaUserPermissionListResponse
				this.setState({
					teamName: reformatdata1.length > 0 ? reformatdata1[0].analytics_team__team_name : '',
					teamId: reformatdata1.length > 0 ? reformatdata1[0].analytics_team_id : '',
				});
				const fd = {
					'teamName': reformatdata1.length > 0 ? reformatdata1[0].analytics_team__team_name : '',
					'teamId': reformatdata1.length > 0 ? reformatdata1[0].analytics_team_id : '',
					'orgId': +this.props.match.params.id
				}
				this.props.dispatch(saveTeamDetailsAction.saveTeamDetailHandler(fd))

				let assessorIds = [];
				let assessmentIds = [];
				if (reformatdata1.length !== 0 && reformatdata1 !== '') {
					const team = {
						"team_id": reformatdata1[0].analytics_team_id
					}
					this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
						this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))

						const assessorGroups = this.props.assessorGroupsResponse
						for (let i = 0; i < assessorGroups.assessor_groups_for_team.length; i++) {
							assessorIds.push(assessorGroups.assessor_groups_for_team[i].id)
						}
						for (let i = 0; i < assessorGroups.team_members.length; i++) {
							assessmentIds.push(assessorGroups.team_members[i].assessment.id)
						}
						const fd = {
							"assessorIds": assessorIds,
							"assessmentIds": assessmentIds,
						}
						this.props.dispatch(analyseActions.saveAssessorIds(fd))
					}))
				} else {
					this.props.dispatch(analyseActions.saveAssessorGroups())
					const fd = {
						"assessorIds": assessorIds,
						"assessmentIds": assessmentIds,
					}
					this.props.dispatch(analyseActions.saveAssessorIds(fd))
				}

				localStorage.setItem('teamId', reformatdata1.length > 0 ? reformatdata1[0].analytics_team_id : '')
				localStorage.setItem('teamName', reformatdata1.length > 0 ? reformatdata1[0].analytics_team__team_name : '')
			}))
		}
		else {
			const { teamId, teamName } = this.props.saveTeamDetailsResponse
			this.setState({
				teamName: teamName,
				teamId: teamId,
			});
			localStorage.setItem('teamId', teamId)
			localStorage.setItem('teamName', teamName)
		}
	}

	// onChangeTeam = (teamDetails) => {
	// 	const team = {
	// 		"team_id": teamDetails.analytics_team_id
	// 	}
	// 	this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
	// 		this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
	// 	}))
	// }

	stateHandler(key) {
		this.setState({ view_detailed_comparison: key, id: key === null ? null : this.state.id })
	}

	render() {
		const { navData } = this.state;
		const { saveAssesorGroupListResponse } = this.props;

		const comparisonData = [
			{
				id: 0,
				name: 'Team',
				bgColor: '#007bff',
				type: [{
					heading: 'ACHIEVEMENT',
					sub_heading: 'Ability to achieve results: Me Vs My Team',
					data: [{
						title: "Aspiration",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Ownership",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Optimization",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Planning",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}, {
						title: "Time sense",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'RELATIONSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Team',
					data: [{
						title: "Expression",
						sub_title: 'Set vision / goals for yourself',
						title_value: 7,
						sub_title_value: 9,
					}, {
						title: "Acceptance",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Resposibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Appropriateness",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEADERSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Team',
					data: [{
						title: "Influence",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Empowerment",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Credibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Task involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEARNING',
					sub_heading: 'Ability to achieve results: Me Vs My Team',
					data: [{
						title: "Urge to learn",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Openness",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Initiative",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Understanding",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'NURTURING',
					sub_heading: 'Ability to achieve results: Me Vs My Team',
					data: [{
						title: "Outspokeness",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Concern",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Authenticity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Conviction",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Context Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}]
			},
			{
				id: 1,
				name: 'Organization',
				bgColor: '#743313',
				type: [{
					heading: 'ACHIEVEMENT',
					sub_heading: 'Ability to achieve results: Me Vs My Organisation',
					data: [{
						title: "Aspiration",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Ownership",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Optimization",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Planning",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}, {
						title: "Time sense",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'RELATIONSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Organisation',
					data: [{
						title: "Expression",
						sub_title: 'Set vision / goals for yourself',
						title_value: 8,
						sub_title_value: 9,
					}, {
						title: "Acceptance",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Resposibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Appropriateness",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEADERSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Organisation',
					data: [{
						title: "Influence",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Empowerment",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Credibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Task involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEARNING',
					sub_heading: 'Ability to achieve results: Me Vs My Organisation',
					data: [{
						title: "Urge to learn",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Openness",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Initiative",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Understanding",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'NURTURING',
					sub_heading: 'Ability to achieve results: Me Vs My Organisation',
					data: [{
						title: "Outspokeness",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Concern",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Authenticity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Conviction",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Context Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}]
			},
			{
				id: 2,
				name: 'Designation',
				bgColor: '#005F08',
				type: [{
					heading: 'ACHIEVEMENT',
					sub_heading: 'Ability to achieve results: Me Vs My Designation',
					data: [{
						title: "Aspiration",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Ownership",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Optimization",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Planning",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}, {
						title: "Time sense",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'RELATIONSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Designation',
					data: [{
						title: "Expression",
						sub_title: 'Set vision / goals for yourself',
						title_value: 6,
						sub_title_value: 9,
					}, {
						title: "Acceptance",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Resposibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Appropriateness",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEADERSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Designation',
					data: [{
						title: "Influence",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Empowerment",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Credibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Task involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEARNING',
					sub_heading: 'Ability to achieve results: Me Vs My Designation',
					data: [{
						title: "Urge to learn",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Openness",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Initiative",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Understanding",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'NURTURING',
					sub_heading: 'Ability to achieve results: Me Vs My Designation',
					data: [{
						title: "Outspokeness",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Concern",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Authenticity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Conviction",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Context Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}]
			},
			{
				id: 3,
				name: 'Experience',
				bgColor: '#BE005A',
				type: [{
					heading: 'ACHIEVEMENT',
					sub_heading: 'Ability to achieve results: Me Vs My Experience',
					data: [{
						title: "Aspiration",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Ownership",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Optimization",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Planning",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}, {
						title: "Time sense",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'RELATIONSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Experience',
					data: [{
						title: "Expression",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9,
						sub_title_value: 9,
					}, {
						title: "Acceptance",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Resposibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9,
						sub_title_value: 9.5,
					}, {
						title: "Appropriateness",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEADERSHIP',
					sub_heading: 'Ability to achieve results: Me Vs My Experience',
					data: [{
						title: "Influence",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Empowerment",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Credibility",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Task involvement",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'LEARNING',
					sub_heading: 'Ability to achieve results: Me Vs My Experience',
					data: [{
						title: "Urge to learn",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Openness",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Initiative",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Understanding",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Organized",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}, {
					heading: 'NURTURING',
					sub_heading: 'Ability to achieve results: Me Vs My Experience',
					data: [{
						title: "Outspokeness",
						sub_title: 'Set vision / goals for yourself',
						title_value: 9.5,
						sub_title_value: 9,
					}, {
						title: "Concern",
						sub_title: 'Take ownership and achive results',
						title_value: 8,
						sub_title_value: 7,
					}, {
						title: "Authenticity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 5,
						sub_title_value: 9,
					}, {
						title: "Conviction",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 9.2,
						sub_title_value: 9.5,
					}, {
						title: "Context Sensitivity",
						sub_title: 'Explore and evoluate alternatives',
						title_value: 7.9,
						sub_title_value: 9.2,
					}]
				}]
			},
		]



		return (
			<div>
				<Navbar navItems={navData} backgroundColor="black" />
				< div className="container-post-nav">
					{
						<SideNavBar
						analyzeFilterData={saveAssesorGroupListResponse !== '' ? saveAssesorGroupListResponse : null}
						isAnalyse = {true}
						organisationName={localStorage.getItem('orgName')}
						orgId={this.props.match.params.id}
						teamId={this.state.teamId}
						teamName={this.state.teamName}
					// onChangeTeam={(data) => this.onChangeTeam(data)}
					/>
					}
					<div className="analyz-container">
						<AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
						{
							(this.state.id === null && this.state.view_detailed_comparison === null) ?
								<React.Fragment>
									<div className="d-flex flex-row justify-content-center my-5">
										<h6 className="font-weight-bold font-italic text-center col-12 col-md-7">Here is how you compare against your team, your organization, and those with your designation and experience in your organization. The bars represent the corresponding group's average scores and the smilies represent your scores, across the five orientations</h6>
									</div>
									<div className="d-flex flex-row justify-content-center flex-wrap">
										{
											comparisonData.map(
												(data, i) => {
													return <div key={i} className="col-3">
														<div className="d-flex flex-row justify-content-center flex-wrap">
															<div className="col-6 text-white font-weight-bold py-2 my-3 text-center" style={{ backgroundColor: data.bgColor }}><span>{data.name}</span></div>
															<div onClick={() => this.setState({ modal: !this.state.modal, modalContent: data })} className="col-12" style={{ border: '1px solid black', width: '100%', height: '150px' }}></div>
															<button onClick={() => this.setState({ id: data.id, view_detailed_comparison: 'ACHIEVEMENT' })} className="btn text-white font-weight-bold py-2 my-3 text-center" style={{ backgroundColor: 'grey' }}>View Details</button>
														</div>
													</div>
												}
											)
										}
									</div>
								</React.Fragment>
								:
								comparisonData.map(
									(data, i) => {
										return this.state.id !== null && data.id === this.state.id &&
											data.type.map(
												(type, i) => {
													{
														return type.heading === this.state.view_detailed_comparison &&
															<React.Fragment key={i}>
																<h3 className="font-weight-bold font-italic text-center pt-5">
																	{type.sub_heading}
																</h3>
																<h3 className="font-weight-bold text-uppercase text-center py-3">
																	{type.heading}
																</h3>

																<div className="d-flex flex-column mx-0 mx-md-5">
																	{
																		type.data.map((val, key) => {
																			return (
																				<div key={key} className="d-flex flex-row col-12 m-1">
																					<div className="col-3 border px-2 py-3 align-items-center text-left">
																						<h5 className="font-weight-bold mb-0">
																							{val.title}
																						</h5>
																						<h6 className="mb-0">
																							{val.sub_title}
																						</h6>
																					</div>
																					<div className="col-7 border py-3 px-0" style={{ display: 'flex', flexDirection: 'column', }}>
																						<div style={{ display: 'flex', flex: 10, flexDirection: 'row', }}>
																							<div style={{ flex: parseFloat(val.title_value), backgroundColor: 'rgb(54, 117, 208)' }}>
																							</div>
																							<div className="text-left px-1" style={{ flex: (10 - parseFloat(val.title_value)) }}>
																								{parseFloat(val.title_value)}
																							</div>
																						</div>
																						<div style={{ display: 'flex', flex: 10, flexDirection: 'row', }}>
																							<div style={{ flex: parseFloat(val.sub_title_value), backgroundColor: "rgb(30, 71, 130)" }}>
																							</div>
																							<div className="text-left px-1" style={{ flex: 10 - parseFloat(val.sub_title_value) }}>
																								{parseFloat(val.sub_title_value)}
																							</div>
																						</div>
																					</div>
																					<div className="d-flex flex-row col-2 border py-3 align-items-center justify-content-around">
																						<div className="">
																							<i className={`fa ${(val.title_value - val.sub_title_value) > 0 ? "fa-arrow-up" : "fa-arrow-down"} diff`} style={{ color: (val.title_value - val.sub_title_value) <= 0 ? 'rgb(237, 55, 55)' : 'rgb(52, 141, 89)' }}></i>
																						</div>
																						<div className="mb-0 diff" style={{ color: (val.title_value - val.sub_title_value) <= 0 ? 'rgb(237, 55, 55)' : 'rgb(52, 141, 89)' }}>
																							{(val.title_value - val.sub_title_value).toFixed(1)}
																						</div>
																					</div>
																				</div>
																			)
																		})

																	}
																	<div className="d-flex flex-row-reverse justify-content-start align-items-center my-3 py-2">
																		<div className="d-flex flex-row border">
																			<div className="d-flex flex-row px-3 align-items-center">
																				<div className="px-1" style={{ backgroundColor: 'rgb(54, 117, 208)', height: 10, width: 10 }}></div>
																				<h4 className="mb-0 px-1">Org Team 1</h4>
																			</div>
																			<div className="d-flex flex-row px-3 align-items-center">
																				<div className="px-1" style={{ backgroundColor: 'rgb(30, 71, 130)', height: 10, width: 10 }}></div>
																				<h4 className="mb-0 px-1">Org Team 10</h4>
																			</div>
																		</div>
																	</div>
																</div>
																<CircularButtonGroup buttonGroupData={this.state.button_data} swotCatagory={this.state.view_detailed_comparison} singleButton={false} onClick={this.stateHandler.bind(this)} />
															</React.Fragment>
													}
												})
									})

						}
					</div>

				</div>
			</div >
		)
	}
}

function mapStateToProps(state) {
	const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

	const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
	const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
	const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

	const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

	const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
	const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
	const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

	const { assessorGroupsLoading } = state.assessorGroupsReducer;
	const assessorGroupsError = state.assessorGroupsReducer.error;
	const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

	const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;


	return {
		saveModulePermissionsResponse,
		getModulePermissionsListResponse,
		saveTeamDetailsResponse,
		getPaUserPermissionListResponse,
		assessorGroupsResponse,
		saveAssesorGroupListResponse,
		saveAssesorIdsResponse
	}
}

export default connect(mapStateToProps)(Comparison)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/Comparison/index.js